/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BasicSecurityAccount } from '../models/basic-security-account';

@Injectable({
  providedIn: 'root',
})
export class SecurityAccountService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getSecurityAccountsByUserId
   */
  static readonly GetSecurityAccountsByUserIdPath = '/v1/security-accounts';

  /**
   * Get security accounts by user id.
   *
   * Get security accounts by user id.
   *
   * **Authorization policy:**  
   *
   * scopes: openid, profile, api.gallery-custody-habilitation-front-demo.v1 ; end user with minimum authentication level L2
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSecurityAccountsByUserId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSecurityAccountsByUserId$Response(params?: {
    excludeClosedAccounts?: boolean;
    excludeNonTransactionalAccounts?: boolean;
  }): Observable<StrictHttpResponse<Array<BasicSecurityAccount>>> {

    const rb = new RequestBuilder(this.rootUrl, SecurityAccountService.GetSecurityAccountsByUserIdPath, 'get');
    if (params) {
      rb.query('excludeClosedAccounts', params.excludeClosedAccounts, {});
      rb.query('excludeNonTransactionalAccounts', params.excludeNonTransactionalAccounts, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<BasicSecurityAccount>>;
      })
    );
  }

  /**
   * Get security accounts by user id.
   *
   * Get security accounts by user id.
   *
   * **Authorization policy:**  
   *
   * scopes: openid, profile, api.gallery-custody-habilitation-front-demo.v1 ; end user with minimum authentication level L2
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getSecurityAccountsByUserId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSecurityAccountsByUserId(params?: {
    excludeClosedAccounts?: boolean;
    excludeNonTransactionalAccounts?: boolean;
  }): Observable<Array<BasicSecurityAccount>> {

    return this.getSecurityAccountsByUserId$Response(params).pipe(
      map((r: StrictHttpResponse<Array<BasicSecurityAccount>>) => r.body as Array<BasicSecurityAccount>)
    );
  }

}
